import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CalendarComponent } from './calendar/calendar.component';
import { AuthGuardService } from './core/authguard.service';
import { CreatePostComponent } from './create-post/create-post.component';
import { DayComponent } from './day/day.component';
import { LoginComponent } from './login/login.component';
import { ModifyPostComponent } from './modify-post/modify-post.component';
import { RegisterComponent } from './register/register.component';

const routes: Routes = [
  {
    path: "calendar", 
    component: CalendarComponent, canActivate: [AuthGuardService],
  },
  {
    path: "day/:date",
    component: DayComponent , canActivate: [AuthGuardService]
  },
  {
    path: "login",
    component: LoginComponent
  },
  {
    path: "",
    component: CalendarComponent , canActivate: [AuthGuardService]
  },
  {
    path: "register",
    component: RegisterComponent, canActivate: [AuthGuardService]
  },
  {
    path: "create-post/:date",
    component: CreatePostComponent, canActivate: [AuthGuardService]
  },
  {
    path: "modify/:id",
    component: ModifyPostComponent, canActivate: [AuthGuardService]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
